import { maybe, rd } from '@passionware/monads';
import { WithServices } from 'v5/platform/ts/services';
import { WithDevOriginService } from 'v5/services/front/DevOriginService/DevOriginService';
import { WithFeatureService } from 'v5/services/front/FeatureService/FeatureService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { DevOriginBadge } from './DevOriginBadge';

export interface DevOriginSidebarBadgeProps
  extends WithServices<
    [WithDevOriginService, WithFeatureService, WithAppScopeService]
  > {
  className?: string;
}

/**
 * The dev server's branch and folder at the sidebar foot, behind `dev-origin` — so local apps open
 * side by side are told apart. Follows a checkout while the server keeps running; renders nothing
 * outside `npm run dev`.
 */
export function DevOriginSidebarBadge({
  services,
  className
}: DevOriginSidebarBadgeProps) {
  const isEnabled = rd.getOrElse(
    services.featureService.useFeature(
      services.appScopeService.useOrganizationScopeIdentity(),
      'dev-origin'
    ),
    false
  );
  const origin = services.devOriginService.useOrigin();

  if (!isEnabled || maybe.isAbsent(origin)) {
    return null;
  }
  return <DevOriginBadge origin={origin} className={className} />;
}
